"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEEP_LINK_DOMAINS = exports.APP_LINK_DOMAIN = exports.ONELINK_DOMAIN_DEV = exports.ONELINK_DOMAIN_PROD = exports.APP_SCHEME = exports.IS_DEV = exports.IS_PROD = exports.IS_LOCAL = exports.ANDROID_BUNDLE_ID_DEV = exports.ANDROID_BUNDLE_ID_PROD = exports.IOS_BUNDLE_ID_DEV = exports.IOS_BUNDLE_ID_PROD = exports.APP_SCHEME_DEV = exports.APP_SCHEME_PROD = void 0;
exports.APP_SCHEME_PROD = 'stella';
exports.APP_SCHEME_DEV = 'stella-dev';
exports.IOS_BUNDLE_ID_PROD = 'com.seestella.stella';
exports.IOS_BUNDLE_ID_DEV = 'com.seestella.stella.dev';
exports.ANDROID_BUNDLE_ID_PROD = 'com.seestella.stella';
exports.ANDROID_BUNDLE_ID_DEV = 'com.seestella.stella.dev';
const IS_LOCAL = (env) => {
    return env === 'dev.local' || env === 'prod.local';
};
exports.IS_LOCAL = IS_LOCAL;
const IS_PROD = (env) => {
    return env === 'prod' || env === 'prod.local';
};
exports.IS_PROD = IS_PROD;
const IS_DEV = (env) => {
    return env === 'dev' || env === 'dev.local';
};
exports.IS_DEV = IS_DEV;
const APP_SCHEME = (env) => {
    return (0, exports.IS_PROD)(env) ? exports.APP_SCHEME_PROD : exports.APP_SCHEME_DEV;
};
exports.APP_SCHEME = APP_SCHEME;
exports.ONELINK_DOMAIN_PROD = 'seestella.onelink.me';
exports.ONELINK_DOMAIN_DEV = 'seestella-dev.onelink.me';
exports.APP_LINK_DOMAIN = 'app.seestella.co';
/**
 * All external domains that route into the app via Universal Links / App Links.
 * Used to suppress Expo Router from trying to route these paths as screens.
 */
exports.DEEP_LINK_DOMAINS = [
    exports.ONELINK_DOMAIN_PROD,
    exports.ONELINK_DOMAIN_DEV,
    exports.APP_LINK_DOMAIN,
];
//# sourceMappingURL=constants.js.map